import { useState } from 'react';
import { IoIosArrowUp } from 'react-icons/io';
import { RiArrowRightSLine } from 'react-icons/ri';

type ATMAccordionPropValue ={
    children : React.ReactNode,
    childrenTitle : React.ReactNode
}
const ATMAccordion = ({ children, childrenTitle }: ATMAccordionPropValue) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="bg-white shadow rounded-lg mb-4">
            <div
                className="flex gap-2 w-full p-2 cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className='mt-1'>{isOpen ? <IoIosArrowUp color="#00a4bd" /> : <RiArrowRightSLine color="#00a4bd" />}</span>
                <h2 className="flex-1 text-lg font-semibold">{childrenTitle}</h2>
            </div>
            {isOpen && <div className="p-2">{children}</div>}
        </div>
    );
};

export default ATMAccordion;